<template>
  <div style="position: relative">
    <img
      :src="`${publicPath}/icons/ai-response/gear.svg`"
      alt=""
      height="60"
      class="gear-icon"
    />
    <img
      :src="`${publicPath}/icons/ai-response/glare.svg`"
      alt=""
      height="60"
      class="glare-icon"
    />
  </div>
</template>

<script>
import constants from '@/util/constants';

export default {
  name: 'AiChatIcon',
  data() {
    return {
      publicPath: constants.isDevelopment ? "" : ""
    }
  },
};
</script>

<style scoped>
.glare-icon {
  position: absolute;
}

.gear-icon {
  position: absolute;
}
</style>
